import { useSelector } from 'react-redux';
import { phoneCountryCodeContactSelector } from 'redux/selectors/caseCreation';
import { providerToCountry } from 'mappers/providers';
import { selectProvider } from 'redux/selectors/config';
import {
  InputLabel,
  PhoneNumberInput,
  PhoneInputContainer,
  PhoneCountryCodeSelector,
} from './PhoneNumberWithCodeStyled';
import { usePhoneNumberCode } from './phoneNumberCodeHook';
import { useTranslate } from 'hooks/translation-hooks';

const PhoneNumberWithCode = ({
  register,
  errors,
  variation,
  setValue,
  title,
}) => {
  const t = useTranslate('caseOpening');
  const phoneCountryCodeDefaultName = 'phoneCountryCode';
  const phoneCountryCodeName = variation
    ? `${phoneCountryCodeDefaultName}${variation}`
    : phoneCountryCodeDefaultName;
  const countrySelected = useSelector(phoneCountryCodeContactSelector);
  const { countryDialCodes, handleChange, pattern } = usePhoneNumberCode({
    setValue,
    countrySelected,
    phoneCountryCodeName,
    defaultCountryCode: providerToCountry[useSelector(selectProvider)],
  });

  return (
    <>
      <InputLabel>{t(title || 'case_identification-phone')}</InputLabel>
      <PhoneInputContainer>
        <PhoneCountryCodeSelector
          register={register}
          name={phoneCountryCodeName}
          options={countryDialCodes}
          handleChange={handleChange}
          hasDefaultOption={false}
          testId="phoneCountryCode"
        />
        <PhoneNumberInput
          register={register}
          errors={errors}
          variation={variation}
          pattern={pattern}
          notShowLayer={true}
        />
      </PhoneInputContainer>
    </>
  );
};

export default PhoneNumberWithCode;
